module.exports = __webpack_public_path__ + "img/gws_logo.c669f377.png";